import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { useCallback, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "../../../components/FormInput";
import { FormInputFile } from "../../../components/FormInputFile";
import FormNumberInput from "../../../components/FormNumberInput";
import { FormTextarea } from "../../../components/FormTextarea";
import ImagePDFComponent from "../../../components/ImagePDFComponent";
import { AlertService } from "../../../utility/service/alert-service";
import { handleFileDownloadRes } from "../../../utility/service/api-base";
import { downloadMultipartFile } from "../../../utility/service/api-file";
import { F1010342Before, F1010343Before } from "../../../utility/service/carbon-service";
import {
  checkDpSuccess,
  getFormErrorMessage,
  splitFileExtension,
  splitFileName,
} from "../../../utility/service/tool-service";
import { addFormValidator } from "../../../utility/validate/formValidator";
import {
  EmissionCase1_1,
  EmissionCase1_10,
  EmissionCase1_2,
  EmissionCase1_4_5_6,
  EmissionCase1_8,
  EmissionCase1_9,
  EmissionCase3711,
} from "./CusEmissionCase";

// 自定義變更計算
const AddCustomEmission = ({
  register,
  errors,
  control,
  detailCase = "1-1",
  rateTypeList,
  fileInputRef,
  setValue,
  getValues,
  cusObj,
  watch,
  disabled,
}) => {
  const { t } = useTranslation();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [zoomSrc, setZoomSrc] = useState(null);
  const [fileInfo, setFileInfo] = useState({});
  const [formRule, setFormRule] = useState([]); //表單驗證
  const excludeCusEmissionCase = ["1-1", "1-2", "1-3", "1-4", "1-5", "1-6", "1-7", "1-8", "1-9", "1-10", "1-11"];

  useEffect(() => {
    if (cusObj?.hasCustom === "Y") {
      axios_getUpdateBefore();
      if (cusObj?.fileExtension !== null) {
        setZoomSrc(cusObj?.filePath); //原圖
        if (cusObj?.fileExtension === "pdf") {
          setPreviewUrl(cusObj?.filePath); //原圖
        } else {
          setPreviewUrl(cusObj?.filePathSml); //縮圖
        }
        setFileInfo({
          type: cusObj?.fileExtension,
          name: `${cusObj?.fileName}.${cusObj?.fileExtension}`,
        });
      }
    } else {
      //建立
      axios_getCreateBefore();
    }
  }, [cusObj]);

  //建立前查詢form 規則
  const axios_getCreateBefore = () => {
    F1010342Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const axios_getUpdateBefore = () => {
    F1010343Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };

  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule]
  );

  const handleFileChange = (e) => {
    //每次開啟選擇檔案觸發onChange事件
    if (e.target.files[0]) {
      if (e.target.files[0].size >= 20000000) {
        AlertService.ok("Error", "Size over 20MB");
        setPreviewUrl(null);
        setZoomSrc(null);
        setValue("fileExtension", ""); //副檔名
        setValue("fileName", ""); //檔名
        setValue("customFile", "");
        setFileInfo({});
        fileInputRef.current.value = null;
      } else {
        setPreviewUrl(URL.createObjectURL(e.target.files[0]));
        setZoomSrc(URL.createObjectURL(e.target.files[0]));

        let fileExtension = splitFileExtension(e.target.files[0]?.name);
        setValue("fileExtension", fileExtension); //副檔名
        setValue("fileName", splitFileName(e.target.files[0]?.name));
        setFileInfo(e.target.files[0]);

        setValue("customFile", e.target.files[0], { shouldValidate: true }); //檔案格式 原圖 如果轉為MulitPart 需解開此
      }
    }
  };

  const handleDeleteImg = () => {
    //刪除圖片
    if (fileInputRef?.current?.value !== undefined) {
      fileInputRef.current.value = null;
      setPreviewUrl(null);
      setZoomSrc(null);
      setValue("fileExtension", ""); //副檔名
      setValue("fileName", ""); //檔名
      setValue("customFile", "");
    }
  };

  //zip 才能點下載
  const downloadItem = (rowData) => {
    if (
      getValues("fileName") === rowData?.fileName &&
      getValues("fileExtension") === rowData?.fileExtension &&
      rowData?.fileId !== null
    ) {
      //存在於資料庫的才去call 下載API
      downloadMultipartFile({
        fileId: rowData?.fileId,
      }).then((res) => {
        if (res?.status === 200) {
          handleFileDownloadRes(res, `${rowData.fileName}.zip`);
        } else {
          AlertService.ok(res?.data?.ResHeader?.rtnCode, res?.data?.ResHeader?.rtnMsg);
        }
      });
    } else {
      //還沒上傳到server的 用原始file 下載
      const reader = new FileReader();
      reader.onload = () => {
        // 檔案內容已載入，可以進行下載
        const fileContent = reader.result;
        const a = document.createElement("a");
        a.href = fileContent;
        a.download = `${getValues("fileName")}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };
      reader.readAsDataURL(getValues("customFile"));
    }
  };

  return (
    <form className="grid">
      <div className="col-12 lg:col-6">
        <label className="label-has-icon">{t("emission_source_type")}:</label>
        <span>{cusObj?.typeName}</span>
      </div>
      <div className="col-12 lg:col-6">
        <label className="label-has-icon">{t("equipment")}:</label>
        <span>{cusObj?.deviceName}</span>
      </div>
      <div className="col-12">
        <label className="label-has-icon">{t("emission_source")}:</label>
        <span>{cusObj?.sourceName}</span>
      </div>
      {cusObj?.detailCase === "1-1" ? (
        <EmissionCase1_1
          register={register}
          errors={errors}
          setValidForm={setValidForm}
          getValues={getValues}
          t={t}
          watch={watch}
          setValue={setValue}
          disabled={disabled}
        />
      ) : (
        <>
          {cusObj?.detailCase === "1-2" && (
            <EmissionCase1_2
              register={register}
              errors={errors}
              setValidForm={setValidForm}
              getValues={getValues}
              t={t}
              watch={watch}
              setValue={setValue}
              disabled={disabled}
            />
          )}
          {(cusObj?.detailCase === "1-3" || cusObj?.detailCase === "1-7" || cusObj?.detailCase === "1-11") && (
            <EmissionCase3711
              detailCase={cusObj?.detailCase}
              register={register}
              errors={errors}
              getValues={getValues}
              setValidForm={setValidForm}
              t={t}
              watch={watch}
              setValue={setValue}
              disabled={disabled}
            />
          )}
          {cusObj?.detailCase === "1-4" && (
            <EmissionCase1_4_5_6
              register={register}
              errors={errors}
              setValidForm={setValidForm}
              customTitle="escape_rate"
              t={t}
              watch={watch}
              setValue={setValue}
              disabled={disabled}
            />
          )}
          {cusObj?.detailCase === "1-5" && (
            <EmissionCase1_4_5_6
              register={register}
              errors={errors}
              setValidForm={setValidForm}
              customTitle="residue_rate"
              t={t}
              watch={watch}
              setValue={setValue}
              disabled={disabled}
            />
          )}
          {cusObj?.detailCase === "1-6" && (
            <EmissionCase1_4_5_6
              register={register}
              errors={errors}
              setValidForm={setValidForm}
              customTitle="leak_rate"
              t={t}
              watch={watch}
              setValue={setValue}
              disabled={disabled}
            />
          )}
          {cusObj?.detailCase === "1-8" && (
            <EmissionCase1_8
              register={register}
              errors={errors}
              setValidForm={setValidForm}
              getValues={getValues}
              t={t}
              watch={watch}
              setValue={setValue}
              disabled={disabled}
            />
          )}
          {cusObj?.detailCase === "1-9" && (
            <EmissionCase1_9
              register={register}
              errors={errors}
              setValidForm={setValidForm}
              getValues={getValues}
              t={t}
              watch={watch}
              setValue={setValue}
              disabled={disabled}
            />
          )}
          {cusObj?.detailCase === "1-10" && (
            <EmissionCase1_10
              register={register}
              errors={errors}
              setValidForm={setValidForm}
              getValues={getValues}
              t={t}
              watch={watch}
              setValue={setValue}
              disabled={disabled}
            />
          )}
          {!excludeCusEmissionCase.includes(cusObj?.detailCase) && (
            <>
              <div className={`col-12 lg:col-6 flex`}>
                <FormNumberInput
                  wrapperClass="w-full"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  disabled={disabled}
                  id="customRate1"
                  name="customRate1"
                  labelText={t("customRate")}
                  rules={setValidForm("customRate1")}
                  value={watch("customRate1")}
                  onChange={(newValue) => setValue("customRate1", newValue)}
                />
                <div className="form-label-has-top-space">
                  <label htmlFor="gasRateUnit1">{getValues("gasRateUnit1")}</label>
                </div>
              </div>
              <div className="col-12 lg:col-6 flex">
                <FormNumberInput
                  wrapperClass="w-full"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  disabled={disabled}
                  id="gwpValue"
                  name="gwpValue"
                  labelText={t("gasGwp")}
                  rules={setValidForm("gwpValue")}
                  value={watch("gwpValue")}
                  onChange={(newValue) => setValue("gwpValue", newValue)}
                />
                <div className="block lg:hidden form-label-has-top-space">
                  <label htmlFor="gasRateUnit1">{getValues("gasRateUnit1")}</label>
                </div>
              </div>
            </>
          )}
        </>
      )}
      <div className="col-12">
        <FormInput
          labelClass="required"
          withLabel={false}
          register={register}
          errors={errors}
          disabled={disabled}
          id="customRateSource"
          name="customRateSource"
          placeholder={t("validation.limitMaxChar", { max: 50 })}
          labelText={t("customRateSource")}
          type="text"
          rules={setValidForm("customRateSource")}
        />
      </div>
      {/* 係數種類   */}
      <div className="col-12">
        <label htmlFor="customRateType" className="form-label required">
          {t("rateType")}
        </label>
        <Controller
          name="customRateType"
          control={control}
          rules={setValidForm("customRateType")}
          render={({ field, fieldState }) => (
            <Dropdown
              filter
              optionLabel="subitemName"
              optionValue="subitemNo"
              value={field.value}
              disabled={disabled}
              defaultValue={""}
              placeholder={t("plz_chs")}
              name="customRateType"
              control={control}
              options={rateTypeList}
              className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
              onChange={(event) => {
                field.onChange(event.value);
              }}
            />
          )}
        />
        {getFormErrorMessage(errors, "customRateType")}
      </div>
      {/* Not needed temporarily */}
      {/* <div className='col-12'>
                <FormInput
                    labelClass=""
                    withLabel={true}
                    register={register}
                    errors={errors}
                    id="customEmission"
                    name="customEmission"
                    labelText={t("customEmission")}
                    type="text"
                    rules={setValidForm("customEmission")}
                />
            </div> */}
      <div className="col-12">
        <FormTextarea
          register={register}
          errors={errors}
          id="customDesc"
          name="customDesc"
          type="text"
          disabled={disabled}
          labelText={t("customDesc")}
          labelClass="required"
          areaClass="w-full"
          placeholder={t("validation.limitMaxChar", { max: 1000 })}
          rules={setValidForm("customDesc")}
        />
      </div>
      {/* 佐證資料檔案 */}
      <div className="col-12">
        <label htmlFor="customFile" className={`form-label ${cusObj?.hasCustom === "N" ? "required" : ""}`}>
          {t("supportingInfo")}
        </label>

        <FormInputFile
          register={register}
          errors={errors}
          acceptFileType=".jpg,.png,.pdf,.zip"
          disabled={disabled}
          id="customFile"
          name="customFile"
          limitSize="20MB"
          fileChange={(e) => {
            handleFileChange(e);
          }}
          rules={{
            required: { value: cusObj?.hasCustom === "N" ? true : false, message: t("validation.required") },
          }}
          fileInputRef={fileInputRef}
        />

        {getValues("fileExtension") !== "zip" && (
          <ImagePDFComponent
            wrapperClass="mt-2"
            file={fileInfo}
            previewUrl={previewUrl}
            zoomSrc={zoomSrc}
            disabled={disabled}
            deleteImg={handleDeleteImg}
          />
        )}

        {watch("fileExtension") === "zip" && (
          <div className="flex flex-wrap lg:flex-nowrap align-items-center">
            <label>
              {watch("fileName")}
              {watch("fileName") !== "" ? "." : ""}
              {watch("fileExtension")}
            </label>
            <Button
              type="button"
              icon="pi pi-trash"
              tooltip={t("button.delete")}
              tooltipOptions={{ position: "top" }}
              className="p-button-icon-only"
              rounded
              text
              disabled={disabled}
              severity="danger"
              onClick={(e) => {
                handleDeleteImg(e);
              }}
            ></Button>

            <Button
              rounded
              text
              severity="secondary"
              className="p-button-icon-only"
              type="button"
              tooltip={t("button.download")}
              tooltipOptions={{ position: "top" }}
              onClick={() => {
                downloadItem(cusObj);
              }}
            >
              <FontAwesomeIcon icon="fa-solid fa-cloud-arrow-down" />
            </Button>
          </div>
        )}
      </div>
    </form>
  );
};

export default AddCustomEmission;
